import { Person as PersonIcon } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import Container from '@mui/material/Container';
import type { FunctionComponent } from 'react';

import { Headline } from '../Typography';
import { getUserInitials } from './common';

const style = { bgcolor: 'secondary.main', border: 'solid 0.125rem white', height: '6rem', width: '6rem' };

type LargeAvatarProps = {
    readonly firstName: string;
    readonly lastName: string;
};

export const AvatarLarge: FunctionComponent<LargeAvatarProps> = (props) => {
    const initials = getUserInitials(props.firstName, props.lastName);

    return (
        <Container>
            <Avatar sx={style}>
                <Headline variant="h3">{initials}</Headline>
            </Avatar>
        </Container>
    );
};

export const AvatarLargeAnonymized: FunctionComponent = () => (
    <Container>
        <Avatar sx={style}>
            <PersonIcon fontSize="large" />
        </Avatar>
    </Container>
);
